import { render } from "./CustomizeResourceTableRow.vue?vue&type=template&id=9bedda48"
import script from "./CustomizeResourceTableRow.vue?vue&type=script&lang=js"
export * from "./CustomizeResourceTableRow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomizeResourceTableRow.vue"]])

export default __exports__